<div [ngClass]="{'d-none': !visible}" class="col-auto form-group">
	<label class="d-block">{{labelName}}</label>
	<label class="font-weight-bold d-block mt-3 labelinfo" [ngClass]="extraClass" style="width: max-content;"
		   ngbPopover={{tooltipMessage}}
		   popoverTitle={{tooltipTitle}}
		   container="body"
		   triggers="mouseenter:mouseleave">{{infoText}}</label>
</div>
